<template>
    <div class="tabel-search">
        <el-form ref="searchForm" :model="searchForm" :size="searchConfig.size|| 'small' " :label-width="searchConfig.labelWidth || '0'">
            <el-form-item v-for="(i, index) in searchConfig.items" :key="index" 
            :style="{marginRight: searchConfig.itemMargin || '20px'}" 
            :label="i.label" 
            :label-width="i.labelWidth">
                <slot></slot>
                <!--输入框-->
                <el-input  v-if="!i.valueType || i.valueType === 'text'" :placeholder="i.placeholder || '请输入'" v-model="searchForm[i.key]"></el-input>
                <!--下拉框-->
                <el-select clearable  v-model="searchForm[i.key]" v-if="i.valueType === 'select'" :placeholder="i.placeholder || '请选择'">
                    <el-option
                            v-for="item in i.data"
                            :key="item.value"
                            :label="(i.option && item[i.option['label']]) ? item[i.option['label']] : item.label"
                            :value="(i.option && item[i.option['value']]) ? item[i.option['value']] : item.value">
                    </el-option>
                </el-select>
                <span class="form-select-tree" v-if="i.valueType === 'tree-selected'">
								<el-select  clearable class="form-select-drop"  v-model="searchForm[i.key]" placeholder="请选择区域">
									<el-option class="form-select-drop-options" value=''>
										<el-tree :props="areaProps" @current-change="currentChange" @node-click="nodeClick(i)" :load="loadNode" lazy> </el-tree>
									</el-option>
								</el-select>
							</span>
                <div v-if="i.valueType === 'switch'" style="margin-right: 20px">
                    <span style="color: #ccc; margin: 0 10px 0 20px">{{
                        i.placeholder || "是否显示下级"
                    }}</span>
                    <el-switch
                        @change="i.fn ? i.fn() : searchData()"
                        v-model="searchForm[i.key]"
                        active-color="rgb(255, 73, 73)"
                    >
                    </el-switch>
                </div>
                <!-- 联级下拉框 -->
                <el-cascader
                        v-model="searchForm[i.key]" v-if="i.valueType === 'cascader'"
                        :placeholder="i.placeholder || '请选择'"
                        :show-all-levels="i.config && i.config.showAllLevels ? i.config.showAllLevels : false"
                        :props="initCascaderProp(i)"></el-cascader>
                <!--时间日期范围选择器-->
                <el-date-picker
                        v-if="i.valueType === 'datetimerange'"
                        v-model="searchForm[i.key]"
                        type="datetimerange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="至"
                        :start-placeholder="initPlaceholder(i.placeholder, 0) || '开始日期'"
                        :end-placeholder="initPlaceholder(i.placeholder, 1) || '结束'">
                </el-date-picker>
                <!--日期选择器-->
                <el-date-picker
                        v-if="i.valueType === 'date'"
                        v-model="searchForm[i.key]"
                        type="date"
                        value-format="yyyy-MM-dd"
                        :placeholder="i.placeholder || '请选择日期'">
                </el-date-picker>
                <!--日期时间选择器-->
                <el-date-picker
                        v-if="i.valueType === 'datetime'"
                        v-model="searchForm[i.key]"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :placeholder="i.placeholder || '请选择时间'">
                </el-date-picker>
                <!--日期范围选择器-->
                <el-date-picker
                        class="date-range-box"
                        v-if="i.valueType === 'daterange'"
                        v-model="searchForm[i.key]"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        :start-placeholder="initPlaceholder(i.placeholder, 0) || '开始日期'"
                        :end-placeholder="initPlaceholder(i.placeholder, 1) || '结束'">
                </el-date-picker>
				<!-- 月选择器 -->
				<el-date-picker
					v-if="i.valueType === 'month'"
					v-model="searchForm[i.key]"
					type="month"
					value-format="yyyy-MM"
					:placeholder="i.placeholder || '请选择月份'">
				</el-date-picker>
                <span   v-if="i.valueType === 'treeSelect'">
<!--              placeholder 提示    clearable 搜索  options 数据  multiple 是否可多选  -->
<!--              :close-on-select="closeOnSelect"-->
<!--              :always-open="alwaysOpen"-->
                  <tree-select
                    style="width: 239px"
                    :options="i.options"
                    :placeholder="i.placeholder"
                    v-model="searchForm[i.key]"
                    :multiple="i.multiple"
                    :clearable="true"
                    :searchable="i.searchable?i.searchable:false"
                    :disabled="i.disabled?i.disabled:false"
                    :open-on-click="true"
                    :clear-on-select="i.multiple?i.multiple:false"
                    :limit="i.limit?i.limit:5"
                    :max-height="i.height?Number(i.height):200"
                  />
<!--                  <treeselect-value  :value="i.value" />-->
                </span>
            </el-form-item>

            <!--按钮-->
            <el-form-item>
                <el-button type="success" @click="searchData()">{{searchTitle?searchTitle:'搜索'}}</el-button>
                <el-button v-if="!reset" @click="resetForm('searchForm')">重置</el-button>
                <el-button v-if="getBack" @click="$router.go(-1)">返回上一页</el-button>

            </el-form-item>

        </el-form>
    </div>
</template>

<script>
      import TreeSelect from '@riophae/vue-treeselect'
     import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import publicAPI from '../../api-path/public-api'
    export default {
        name: "tabel-search",
        components:{TreeSelect},
        props: ['searchConfig', 'searchParams', 'hideReset','getBack','reset','searchTitle'],
        data() {
            return {
                leaf: false,
                props: {
                    lazy: true,
                    value: 'id',
                    label: 'areaName',
                    lazyLoad: this.lazyLoad
                },
                areaProps: {
                    label: 'name',
                    key: 'id',
                    children: 'areaTreeListResList',
                },
                currentNode:{},
            }
        },
        computed: {
            searchForm:  {
                get : function () {
                    return this.searchParams
                },
                set: function (newValue) {
                    return  newValue
                }
            }
        },
        created() {
            this.initSelectData()
        },
        methods: {
            // 连级查询
            lazyLoad(node, resolve) {
                const {level} = node;
                this.$http.get(`${publicAPI.areaListTreeNode}?parentId=${node.data ? node.data.id : 0}`).then(res => {
                    if(res.status === 200) {
                        res.result.map(item => {
                            if(this.leaf) {
                                item.leaf = level >= this.leaf ? true : false
                            }
                        })
                        resolve(res.result)
                    }
                })
            },

            // 初始化联级下拉的配置
            initCascaderProp(c) {
                let props = {
                    lazy: true,
                    lazyLoad: this.lazyLoad,
                    checkStrictly: c.config &&  c.config.checkStrictly ? c.config.checkStrictly : false
                }
                this.leaf = c.config &&  c.config.leaf ? c.config.leaf : false
                props = {...props, ...c.option}
                return props
            },
            // 初始化下拉框和树形的数据
            initSelectData() {
                for (let i of this.searchConfig.items) {
                    if ((i.valueType === 'select' || i.valueType === 'treeSelect') && i.path && !i.data) {
                        this.$http.get(i.path).then(res => {
                            if (res.status === 200) {
                                if (res.result.__proto__ === Array.prototype) {
                                    if (i.valueType === 'select') {
                                        this.$set(i, 'data', res.result)
                                    } else {
                                        this.$set(i, 'options', res.result)
                                    }
                                } else {
                                    if (i.valueType === 'select') {
                                        this.$set(i, 'data', res.result.pageList)
                                    } else {
                                        this.$set(i, 'options', res.result.pageList)
                                    }
                                }
                            }
                        })
                    }
                }
            },

            // 初始化输入框提示信息
            initPlaceholder(placeholder, index) {
                if(!placeholder || placeholder.indexOf(':') === -1) {
                    return false
                }
                let keyValue = placeholder.split(':')
                return keyValue[index]
            },

            // 查询
            searchData() {
                this.searchForm.page = 1;
                let searchForm = {...this.searchForm}
                for(let i in searchForm) {
                    if(typeof searchForm[i] === "boolean" || typeof searchForm[i] === "string" || searchForm[i] === null) {
                        continue
                    }
                    if((i.indexOf('Time') !== -1 || i.indexOf('date') !== -1) && searchForm[i].length > 1) {
                        searchForm[i][1] = searchForm[i][1]
                     }
                }
                this.$emit('search',  searchForm)
            },

            // 重置
            resetForm() {
                this.searchForm = Object.assign(this.searchForm, this.$parent.$options.data()[this.searchConfig.dataName])
                if(this.$listeners.resetCallBack){
                    this.$emit('resetCallBack')
                }else {
                    this.searchData()
                }



            },
            currentChange(node){
                this.currentNode=node;
            },
            nodeClick(item) {
				if(this.currentNode.id){
					item.fn(this.currentNode);
				}
                // this.formData['parentId']=this.currentNode.areaId;
            },
            loadNode(node, resolve) {
				const $this=this;
                if (node.level === 0) {
					let areaId= localStorage.getItem('centerId')?localStorage.getItem('centerId'):'0';
                    this.$http.get(publicAPI.subordinateList,{params: { id: areaId }}).then(res => {
                        if (res.status===200) {
							$this.areaTreeList=res.result.areaTreeListResList;
                            return resolve([res.result]);
                        }
                    })
                }
                if(node.level==1){
					return resolve(this.areaTreeList);
                }

                if (node.level > 1) {
                    this.loadchildnode(node, resolve);
                }
            },
            loadchildnode(node, resolve) {
                this.$http.get(publicAPI.subordinateList,{
                    params: {
                        id: node.data.id
                    }
                }).then(res => {
                    if (res.status===200) {
                        return resolve(res.result.areaTreeListResList);
                    }
                })
            },
        }
    }
</script>

<style scoped lang="less">
 @import "tanel-search";
</style>

<style lang="less"  >
    .tabel-search{
        .el-form-item {
            .el-form-item__label {
                width: 100px;
            }
        }
    }
    .el-tabs__content{
        display: block!important;
    }

</style>
